import * as React from 'react'
import { FlatList, View } from 'react-native'
import styled from '@theme/styled-components'

import Checkbox from '@components/checkbox/Checkbox'

interface Option<T> {
  value: T
  label: string
}

interface Props<T> {
  data: ReadonlyArray<Option<T>>
  onItemSelected: (values: T) => void
  selected: T[]
}

const ListPicker: <T>(props: Props<T>) => React.ReactElement = ({ data, onItemSelected, selected }) => {
  const renderItem = ({ item }: { item: Option<(typeof selected)[number]> }) => {
    const isSelected = selected.includes(item.value)

    return (
      <Item>
        <Checkbox label={item.label} onClick={() => onItemSelected(item.value)} value={isSelected} />
      </Item>
    )
  }

  return (
    <FlatList
      data={data}
      keyExtractor={(item) => JSON.stringify(item.value)}
      renderItem={renderItem}
      extraData={selected}
    />
  )
}

export default ListPicker

const Item = styled(View)`
  padding: 5px 0;
`
